import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {PieceJointe} from './piece-jointe.model';
import {DaoGeneric} from '@Services/base/daoService';
import * as FileSaver from 'file-saver';
import {ModelPjFile} from "app/dar/common/services/model-pj/model-pj.model";

/**
 * Service d'upload / téléversement et de download / téléchargement des fichiers
 */
@Injectable({ providedIn: 'root' })
export class PiecejointeService extends DaoGeneric<PieceJointe> {
  private urlUpload = `${environment.baseUrl}/dar/upload/`;
  private urlDownload = `${environment.baseUrl}/dar/download/`;
  private tempId = 0;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp?: string): string {
    return this.urlUpload;
  }

  /**
   * Upload de fichier
   * @param pieceJointe
   */
  public upload(pieceJointe: PieceJointe): Observable<any> {
    const formData: FormData = new FormData();

    formData.append('file', pieceJointe.file, pieceJointe.file.name);

    if (pieceJointe.dossier) {
      formData.append('dossier', pieceJointe.dossier.toString());
    }

    if (pieceJointe.type_file) {
      formData.append('type_file', pieceJointe.type_file.toString());
    }

    if (pieceJointe.name) {
      formData.append('name', pieceJointe.name);
    }

    return this.httpClient.post(this.urlUpload, formData);
  }

  /**
   * Download de fichier
   * @param {PieceJointe} pj la pièce jointe à télécharger
   */
  public download(pj: PieceJointe) {
    this.getFile(pj.id, 'AttachedFile').subscribe(data => {
      FileSaver.saveAs(data, pj.name);
    });
  }

  public downloadModelPj(pj: ModelPjFile) {
    this.getFile(pj.id, 'AttachmentTemplateFile').subscribe(data => {
      FileSaver.saveAs(data, pj.file_name);
    });
  }

  /**
   * Getfile
   * @param id
   * @param file_type
   */
  public getFile(id: number, file_type: 'AttachedFile' | 'AttachmentTemplateFile' = 'AttachedFile') {
    return this.httpClient.get<Blob>(this.urlDownload, {
      params: {id: id.toString(), file_type: file_type},
      responseType: 'blob' as 'json'
    });
  }

  // getIdUnique(): number {
  //   this.tempId++;
  //   return this.tempId;
  // }
}
